module.exports = "/_next/static/images/minnesota-97bb5183185cffcb8402e8879db89884.svg";